export default __webpack_public_path__ + "static/brown-bear-logo-246eb1bb85599f61ffe043bee4f85267.png";